
<div class="inner">
  <div class="view-item-wrapper">
    <!-- Show loading state during SSR -->
    <div *ngIf="(loading$ | async)" class="loading-state">
      <app-loader></app-loader>
      <p>Loading {{ environment.tokenName }} details...</p>
    </div>

    <!-- Show content when loaded -->
    <ng-container *ngIf="!(loading$ | async)">
      <app-punk-billboard
        [data]="(punk$ | async)">
      </app-punk-billboard>

      <div
        class="details-wrapper"
        *ngIf="(punk$ | async) as punk; else detailsPlaceholder">

      <div class="title-wrapper">
        <div class="left">
          <h1 i18n>{{ environment.tokenName }} {{ punk.id }}</h1>
          <h2 *ngIf="punk.attributes && punk.attributes[0]" i18n>
            One of {{ punk.attributes[0].v | traitCount }} 
            <a
              class="pink"
              [routerLink]="['/', 'all']"
              [queryParams]="getItemQueryParams(punk.attributes[0])">
              
              {{ punk.attributes[0].v }}
            </a> {{ environment.tokenName }}s.
          </h2>
        </div>

        <div class="right">

          <app-ens-metadata [address]="punk.owner?.id" />
          
          <div class="auction-details" *ngIf="false">
            @if (((auction$ | async)?.blocksRemaining || 0) > 0) {
              <a
                class="button auction inverse"
                [routerLink]="['/', 'auction', punk.id]">
    
                View Auction
                <!-- <ng-template [ngTemplateOutlet]="auctionIcon" /> -->
              </a>
            }
          </div>
          <!-- <pre>
            {{ auction$ | async | json }}
          </pre> -->
        </div>
      </div>

      <div class="accessories-wrapper">
        <h2 i18n>Attributes</h2>
        <div class="accessories" *ngIf="punk.attributes.length">
          <ng-container *ngFor="let item of punk.attributes; let i = index">
            <div class="accessory" *ngIf="i > 1">
              <a
                class="value"
                [routerLink]="['/', 'all']"
                [queryParams]="getItemQueryParams(item)">
                
                {{ item.v }}
              </a>
              <span class="trait-count">
                <span>{{ item.v | traitCount }}</span>
                {{ environment.tokenName }}s have this.
              </span>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="market-status">
        <h2 i18n>Current Market Status</h2>

        <ng-container *ngIf="!punk.wrapped; else wrapped">

          <!-- Owner -->
          <p i18n *ngIf="punk.owner?.id as owner">This {{ environment.tokenName }} is currently owned by <a [routerLink]="['/', 'owned']" [queryParams]="{ address: owner }"><app-wallet-address [address]="owner"></app-wallet-address></a>.</p>

          <p i18n *ngIf="environment.collection === 'cryptopunks-v1'" class="bold pink">This {{ environment.tokenName }} is not Wrapped.</p>

        </ng-container>
      
        <!-- <pre>
        wrapped: {{ punk.wrapped }}
        c721wrapped: {{ punk.c721wrapped }}
        </pre> -->
        <!-- Wrapped -->
        <ng-template #wrapped>
          <p i18n class="bold pink">This {{ environment.tokenName }} is Wrapped<ng-container *ngIf="punk.c721wrapped"> (C721)</ng-container><ng-container *ngIf="!punk.c721wrapped && environment.collection === 'cryptopunks'"> (Legacy)</ng-container>.</p>
          <!-- Owner -->
          <p i18n *ngIf="(punk.wrappedOwner || punk.owner?.id) as owner">This {{ environment.tokenName }} is currently owned by <a [routerLink]="['/', 'owned']" [queryParams]="{ address: owner }"><app-wallet-address [address]="owner"></app-wallet-address></a>.</p>
          <!-- {{ punk.listing | json }} -->
        
        </ng-template>

      </div>

      <div class="v1-pairing-status" *ngIf="siblingOwner && environment.crossMarketplaceUrl && environment.featureFlags?.CROSS_MARKETPLACE_COUNTERPART">
        <p i18n *ngIf="siblingPaired">
          This {{ environment.tokenName }} is <span class="bold pink">paired</span> with its&nbsp;
          <a [href]="environment.crossMarketplaceUrl + '/details/' + punk.id" target="_blank" class="sibling-link">
            {{ environment.collection === 'cryptopunks-v1' ? 'V2' : 'V1' }} token
            <svg class="popup-icon" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="currentColor" /></svg>
          </a>.
        </p>
        <p i18n *ngIf="!siblingPaired">
          <a [href]="environment.crossMarketplaceUrl + '/details/' + punk.id" target="_blank" class="sibling-link">
            {{ environment.collection === 'cryptopunks-v1' ? 'V2' : 'V1' }} token
            <svg class="popup-icon" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="currentColor" /></svg>
          </a>
          &nbsp;owned by:
          <a [routerLink]="['/', 'owned']" [queryParams]="{ address: siblingOwner }">
            <app-wallet-address [address]="siblingOwner"></app-wallet-address>
          </a>.
        </p>
      </div>

      <div class="actions-wrapper">

        <div class="action-group">
          <span>{{ nativeMarketplaceSectionTitle }}</span>
        </div>
        
        <!-- Value (Listing) — native / PunksMarket only; externals are under Other marketplaces -->
        <ng-container *ngIf="punk.listing?.value as value; else notListed">
          <ng-container *ngIf="!punk.listing?.source || isPunksmarketNativeListing(punk)">
            <ng-container *ngIf="!(punk.listing?.toAccount?.id) || punk.listing?.toAccount?.id === ZERO_ADDRESS || isPunksmarketNativeListing(punk); else privateListing">
              <p i18n>This {{ environment.tokenName }} is currently for sale for <span class="pink">{{ (value | weiToEth) | formatCash }} ETH</span><span class="bold"> <ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: value }" /></span><ng-container *ngIf="isPunksmarketNativeListing(punk) && !isPunksmarketNativeTradingEnabled()"> on <a [href]="punksmarketDetailUrl(punk)" target="_blank" rel="noopener noreferrer">PunksMarket</a></ng-container><ng-container *ngIf="isPunksmarketNativeListing(punk) && isPunksmarketNativeTradingEnabled()"> on the native marketplace</ng-container>.</p>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Has bid -->
        <ng-container *ngIf="punk.bid as bid; else noBids">
          <p>There is a {{ nativeBidNoun }} of <span class="bold">{{ bid.value | weiToEth | formatCash }} ETH</span> <span class="usd"><ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: bid.value }" /></span> for this {{ environment.tokenName }} from <a [routerLink]="['/', 'owned']" [queryParams]="{ address: bid.fromAccount.id }"><app-wallet-address [address]="bid.fromAccount.id"></app-wallet-address></a>.</p>
        </ng-container>

        <!-- Has on-chain escrow bid -->
        <ng-container *ngIf="isPunksmarketBidSupportEnabled() && highestPunksmarketBid as pmBid">
          <p>
            There is an <app-on-chain-bid-label [iconSize]="14">{{ onChainBidNoun }}</app-on-chain-bid-label> of
            <span class="bold">{{ pmBid.bid_amount_eth | formatCash }} ETH</span>
            <span class="usd"><ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: pmBid.bid_amount_wei }" /></span>
            on this {{ environment.tokenName }}.
          </p>
        </ng-container>

        <!-- Has stash bid -->
        <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && highestStashBid as stashBid">
          <p i18n>
            There is a {{ stashBid.confidential ? 'confidential' : 'public' }} stash bid ({{ stashBid.bidTypeLabel || (stashBid.bidType === 'trait' ? 'Trait Bid' : stashBid.bidType === 'owner' ? 'Owner Bid' : stashBid.bidType === 'custom' ? 'Custom Bid' : 'Collection Bid') }}) of <span class="bold">{{ stashBid.bid_amount_wei | weiToEth | formatCash }} ETH</span> <span class="usd"><ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: stashBid.bid_amount_wei }" /></span> on this {{ environment.tokenName }}.
          </p>
        </ng-container>

        <ng-container *ngIf="(stateSvc.walletAddress$ | async) as address; else notConnected">
          <ng-container *ngIf="punk.owner?.id as owner">

            <ng-container
              *ngIf="
                !(punk.listing?.toAccount?.id) || 
                punk.listing?.toAccount?.id === ZERO_ADDRESS ||
                punk.listing?.toAccount?.id === address ||
                isPunksmarketNativeListing(punk)
              ">

              <a
                *ngIf="isPunksmarketNativeListing(punk) && !isPunksmarketNativeTradingEnabled() && (owner | lowercase) !== (address | lowercase)"
                [href]="punksmarketDetailUrl(punk)"
                target="_blank"
                rel="noopener noreferrer"
                class="button punksmarket"
                i18n>
                Buy on PunksMarket
                <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="rgba(var(--background), 1)" /></svg>
              </a>

              <button
                i18n
                *ngIf="isPunksmarketNativeListing(punk) && isPunksmarketNativeTradingEnabled() && (owner | lowercase) !== (address | lowercase)"
                class="buy"
                [class.locked]="hasDelegationRights$ | async"
                [disabled]="hasDelegationRights$ | async"
                (click)="buyPunkViaPunksmarket(punk)">
                <svg
                  *ngIf="hasDelegationRights$ | async"
                  class="lock-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10z"/>
                </svg>
                Buy
              </button>

              <button
                i18n
                *ngIf="
                  !punk.listing?.source &&
                  !isPunksmarketNativeListing(punk) &&
                  punk.listing &&
                  (owner | lowercase) !== (address | lowercase)
                "
                class="buy"
                [class.locked]="(!sellerApproved && sellerApprovalChecked) || (hasDelegationRights$ | async)"
                (click)="buyPunk(punk)">

                <svg
                  *ngIf="(!sellerApproved && sellerApprovalChecked) || (hasDelegationRights$ | async)"
                  class="lock-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10z"/>
                </svg>
                Buy
              </button>
            </ng-container>

            <!-- Sell/Transfer -->
            <ng-container *ngIf="((owner | lowercase) === (address | lowercase))">

              <button
                i18n
                class="sell"
                (click)="openSellModal()"
                *ngIf="!(environment.collection === 'cryptopunks' && (punk.wrapped || punk.c721wrapped)) && !(environment.collection === 'cryptopunks-v1' && !punk.wrapped && !isPunksmarketNativeTradingEnabled())">
                Offer for Sale
              </button>

              <button
                i18n
                class="transfer"
                (click)="transferModalActive = true">

                Transfer
              </button>

              <button
                i18n
                class="wrap-unwrap"
                (click)="openWrapUnwrapMenu()"
                *ngIf="canShowWrapUnwrapButton">

                {{ wrapUnwrapButtonText }}
              </button>
            </ng-container>

            <!-- Delist -->
            <ng-container *ngIf="((owner | lowercase) === (address | lowercase)) && punk.listing?.value && !punk.listing?.source && (!isPunksmarketNativeListing(punk) || isPunksmarketNativeTradingEnabled())">
              <button
                i18n 
                class="sell"
                (click)="punkNoLongerForSale(punk)">

                Delist
              </button>
            </ng-container>

            <!-- Bid -->
            <button
              *ngIf="((owner | lowercase) !== (address | lowercase)) && (owner | lowercase) !== '0x0000000000000000000000000000000000000000' && !(environment.collection === 'cryptopunks-v1' && !punk.wrapped)"
              class="sell"
              [disabled]="hasDelegationRights$ | async"
              [class.locked]="hasDelegationRights$ | async"
              (click)="bidModalActive = true">

              <svg 
                *ngIf="hasDelegationRights$ | async"
                class="lock-icon" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="currentColor">
                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10z"/>
              </svg>
              {{ placeNativeBidButtonLabel }}
            </button>

            <!-- Withdraw Bid -->
            <button
              *ngIf="((punk.bid?.fromAccount?.id | lowercase) === (address | lowercase))"
              class="sell"
              (click)="withdrawBidForPunk(punk)">

              {{ withdrawNativeBidButtonLabel }}
            </button>

            <!-- Create Individual Bid -->
            <button
              i18n
              *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && ((owner | lowercase) !== (address | lowercase)) && (owner | lowercase) !== '0x0000000000000000000000000000000000000000' && !(environment.collection === 'cryptopunks-v1' && !punk.wrapped)"
              class="sell"
              [disabled]="hasDelegationRights$ | async"
              [class.locked]="hasDelegationRights$ | async"
              (click)="openIndividualBidModal()">

              <svg 
                *ngIf="hasDelegationRights$ | async"
                class="lock-icon" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="currentColor">
                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10z"/>
              </svg>
              Create Stash Bid
            </button>

            <!-- Cancel Bid with Flash Loan for testing purpose -->
            <button
              i18n
              *ngIf="punk.bid && false"
              class="sell"
              (click)="cancelBidWithFlashLoan(punk)">
 
              Cancel Bid
            </button>


            <!-- Accept native marketplace bid -->
            <button
              *ngIf="punk.bid && ((owner | lowercase) === (address | lowercase))"
              class="sell"
              [class.disabled]="isLegacyBidLower"
              (click)="handleAcceptLegacyBidClick()">

              {{ acceptNativeBidButtonLabel }} ({{ (punk.bid.value | weiToEth) | formatCash }}Ξ)
            </button>

            <!-- Cancel Bid with Flash Loan -->
            <button
              *ngIf="punk.bid && ((owner | lowercase) === (address | lowercase) || (hasDelegationRights$ | async))"
              class="sell"
              style="position: relative;"
              (click)="cancelBidWithFlashLoan(punk)">
              {{ cancelNativeBidButtonLabel }}
              <span 
                *ngIf="punk.bid && ((owner | lowercase) === (address | lowercase) || (hasDelegationRights$ | async))"
                tippy
                [options]="{
                  content: 'Remove an existing bid on your Punk. Canceling a bid can be part of your negotiation strategy, whether you want to clear unsolicited offers or signal that the current terms do not work.',
                  placement: 'top',
                  theme: 'punks'
                }"
                class="detail-icon"
                style="position: absolute; right: 1.5rem;">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  height="14" 
                  viewBox="0 0 24 24" 
                  width="14" 
                  fill="black"
                  style="opacity: 0.5; transform: translateY(0.1rem) scale(1.4); cursor: help;">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>              
            </button>

            <!-- Accept on-chain bid (V1 unwrapped; listing to router required before tx) -->
            <ng-container *ngIf="environment.collection === 'cryptopunks-v1' && isPunksmarketBidSupportEnabled() && highestPunksmarketBid && ((owner | lowercase) === (address | lowercase))">
              <button
                class="sell punksmarket"
                [class.disabled]="isPunksmarketBidLower"
                (click)="handleAcceptPunksmarketBidClick()">
                <app-on-chain-bid-label colorMode="contrast">{{ acceptOnChainBidButtonLabel }}</app-on-chain-bid-label> ({{ highestPunksmarketBid.bid_amount_eth || '0' }}Ξ)
              </button>
            </ng-container>

            <button
              *ngIf="environment.collection === 'cryptopunks-v1' && isPunksmarketBidNativeEnabled() && (owner | lowercase) !== (address | lowercase)"
              class="button punksmarket"
              (click)="openPunksmarketPlaceBidModal()">
              <app-on-chain-bid-label colorMode="contrast">{{ placeOnChainBidButtonLabel }}</app-on-chain-bid-label>
            </button>

            <!-- Accept Collection Bid -->
            <ng-container *ngIf="(environment.collection === 'cryptopunks' || environment.collection === 'cryptopunks-v1') && highestCollectionBid && ((owner | lowercase) === (address | lowercase)) && environment.featureFlags?.STASH_BID_SUPPORT !== false">
              <button
                class="sell"
                [class.disabled]="isStashBidLower"
                (click)="handleAcceptStashBidClick()">

                Accept Stash bid ({{ highestStashBid?.bid_amount_eth || highestCollectionBid?.bid_amount_eth || '0' }}Ξ)
              </button>
              <ng-container *ngIf="collectionBids.length >= 1 && (owner | lowercase) !== (address | lowercase)">
                <ng-container *ngTemplateOutlet="collectionBidsLink"></ng-container>
              </ng-container>
            </ng-container>
            

            <ng-container *ngIf="allBids.length >= 1 && (environment.featureFlags?.STASH_BID_SUPPORT !== false || isPunksmarketBidSupportEnabled())">
              <ng-container *ngTemplateOutlet="collectionBidsLink"></ng-container>
            </ng-container>
            
            <!-- Start Auction -->
            @if (((auction$ | async)?.blocksRemaining || 0) < 0 && ((owner | lowercase) === (address | lowercase)) && !(punk.wrapped || punk.c721wrapped) && environment.collection === 'cryptopunks') {
              <button
                class="auction"
                (click)="startAuction(punk)">
                
                Start Auction
              </button>
            }               

            @if (!punk.listing?.source && environment.collection === 'cryptopunks' && !(punk.wrapped || punk.c721wrapped)) {
              <a
                [href]="'/auction/' + punk.id"
                [routerLink]="['/', 'auction', punk.id]"
                class="auction button">
    
                View Auction House
              </a>
            }
    
          </ng-container>
        </ng-container>

        <ng-template #notConnected>
          <button i18n (click)="web3Svc.connect()">Connect an Ethereum wallet to interact with this item</button>

          <ng-container *ngIf="collectionBids.length >= 1">
            <ng-container *ngTemplateOutlet="collectionBidsLink"></ng-container>
          </ng-container>
        </ng-template>

        <div class="action-group" *ngIf="thirdPartyBids.length > 0 || (punk?.reservoirListings ?? []).length > 0">
          <span>Other marketplaces</span>
        </div>              

        <ng-container *ngIf="(punk?.reservoirListings ?? []).length > 0">
 
          <div class="listings-container"> 
            <a
              *ngFor="let listing of punk.reservoirListings"
              [href]="listing.source?.url"
              target="_blank"
              class="button">
              Buy on {{ listing.source?.name ?? 'external marketplace' }} for {{ listing.value | weiToEth | formatCash }} ETH
              <ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: listing.value }" /> 
              <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="rgba(var(--background), 1)" /></svg>
            </a>
          </div>

        </ng-container>       
          
        
        <ng-container *ngIf="thirdPartyBids.length > 0">
          <div style="margin-bottom: 1rem;">
            <span class="pink">{{ thirdPartyBids.length }} offers</span>
            available from other marketplaces — 
            <span tippy [options]="{
                content: thirdPartyBids | thirdPartyBids:usdRate.value,
                placement: 'bottom',
                trigger: 'click', 
                theme: 'punks-dark'
              }" class="pink pointer">
              click here
            </span> 
            to view them.
          </div>
        </ng-container>
      </div>

      <div class="cig-claim-wrapper" *ngIf="environment.collection === 'cryptopunks'">
        <h2 i18n>$CIG Token Status</h2>

        <ng-container *ngIf="punk.cigClaim as cig; else noClaim">
          <p i18n>$CIG for this {{ environment.tokenName }} was claimed by <a [routerLink]="['/', 'owned']" [queryParams]="{ address: cig.owner }"><app-wallet-address [address]="cig.owner"></app-wallet-address></a>.</p>
          <p i18n>The claim was performed on <a href="https://etherscan.com/tx/{{ cig.transactionHash }}" target="_blank">{{ ((+cig.blockTimestamp) * 1000) | date }}</a>.</p>
        </ng-container>

        <ng-template #noClaim>
          <p i18n>$CIG for this {{ environment.tokenName }} has <span class="pink">not</span> been claimed.</p>

          <ng-container *ngIf="(stateSvc.walletAddress$ | async) as address">
            <button
              (click)="claimCig()"
              *ngIf="address === punk.owner?.id">
              
              Claim $CIG
            </button>
          </ng-container>
        </ng-template>

      </div>

      

      <app-tx-history [tokenId]="punk.id"></app-tx-history>


      <!-- Private listing -->
      <ng-template #privateListing>
        <ng-container *ngIf="punk.listing?.toAccount?.id as listedTo">
          <ng-container *ngIf="punk.listing?.toAccount?.id !== ZERO_ADDRESS">
            <p i18n>This {{ environment.tokenName }} is listed privately 
              to <a [routerLink]="['/', 'owned']" [queryParams]="{ address: listedTo }">
                <app-wallet-address [address]="listedTo" /></a>

                <ng-container *ngIf="punk.listing?.value! !== '0'">
                  for Ξ{{ punk.listing?.value! | weiToEth | formatCash }}
                  (${{ ((punk.listing?.value! | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }})
                </ng-container>
                .</p>
          </ng-container>
        </ng-container>
      </ng-template>      
    </div>
    </ng-container>
  </div>
</div>

<div
  class="modal-overlay"
  [class.active]="(isItemViewTransactionActive && (txTrackingSvc.txModalActive$ | async)) || sellModalActive || bidModalActive || transferModalActive || acceptBidModalActive || acceptPunksmarketBidModalActive || acceptPunksmarketListingRequiredModalActive || acceptCollectionBidModalActive || viewAllCollectionBidsModalActive || offerToStashModalActive || acceptCollectionBidFinalModalActive || sellerApprovalWarningModalActive || lowerBidConfirmationModalActive"
  [class]="(isItemViewTransactionActive && (txTrackingSvc.txModalActive$ | async)) ? 'transaction' : ''">

  <div
    #modal
    class="modal"
    [class.collection-bids-modal]="viewAllCollectionBidsModalActive">

    <ng-container *ngIf="(punk$ | async) as punk;">
      <ng-container *ngIf="isItemViewTransactionActive && (txTrackingSvc.txModalActive$ | async)">
        <button class="close-modal" (click)="txTrackingSvc.closeTxModal(); isItemViewTransactionActive = false">x</button>
  
        <ng-container *ngFor="let status of txTrackingSvc.txStatusArray; let i = index">
          <ng-container *ngIf="status.active">
  
            <h3>
              <img
                src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
                width="20" height="20"
                *ngIf="i === 0 || i === 1"
              />
              {{ status.title }}
            </h3>
            
            <span class="p-wrapper" [innerHTML]="status.message || ''"></span>
  
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- SELLER APPROVAL WARNING -->
      <ng-container *ngIf="sellerApprovalWarningModalActive">
        <button class="close-modal" (click)="hideSellerApprovalWarning()">x</button>
        <div class="punk-info">
          <!-- Stash Approval for Bid Acceptance (V1 or V2 wrapped) -->
          <ng-container *ngIf="currentAcceptStep === 'approve'">
            <h2 i18n>Approve Stash Contract</h2>
            <div class="image-wrapper">
              <img
                [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
                width="200"
                height="200"
              />
            </div>
            <ng-container *ngIf="environment.collection === 'cryptopunks' && (punk.wrapped || punk.c721wrapped); else v1Message">
              <p i18n>
                To accept this collection bid, you need to approve the stash contract to transfer your wrapped {{ environment.tokenName }} #{{ punk.id }}.
              </p>
              <p i18n>
                This is a one-time approval that allows the stash contract to transfer your token when you accept the bid.
              </p>
              <p *ngIf="punk.c721wrapped" i18n class="pink">
                Note: This punk is wrapped with C721. You are approving the C721 contract.
              </p>
              <p *ngIf="!punk.c721wrapped && punk.wrapped" i18n class="pink">
                Note: This punk is wrapped with the legacy wrapper. You are approving the legacy wrapper contract.
              </p>
            </ng-container>
            <ng-template #v1Message>
              <p i18n>
                To accept this collection bid, you need to approve the stash contract to transfer your {{ environment.tokenName }} #{{ punk.id }}.
              </p>
              <p i18n>
                This is a one-time approval that allows the stash contract to transfer your token when you accept the bid.
              </p>
            </ng-template>
            <div class="form-actions">
              <button i18n class="cancel" (click)="hideSellerApprovalWarning()">Cancel</button>
              <button i18n class="submit" (click)="approveStashForToken(punk)">Approve Stash</button>
            </div>
          </ng-container>
          
          <!-- Original Seller Approval Warning -->
          <ng-container *ngIf="currentAcceptStep !== 'approve' || environment.collection !== 'cryptopunks-v1'">
            <h2 i18n>⚠️ Purchase Not Available</h2>
            <div class="image-wrapper">
              <img
                [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
                width="200"
                height="200"
              />
            </div>
            <p i18n>
              This {{ environment.tokenName }} cannot be purchased through the marketplace because the seller has revoked the marketplace's authorization to transfer their tokens.
            </p>
            <p i18n>
              <strong>Recommendation:</strong> Contact the seller directly to arrange a private sale or ask them to re-authorize the marketplace.
            </p>
            <p i18n>
              Seller: <app-wallet-address [address]="punk.owner?.id || ''"></app-wallet-address>
            </p>
          </ng-container>
        </div>
    
        <div class="form-actions" *ngIf="currentAcceptStep !== 'approve' || environment.collection !== 'cryptopunks-v1'">
          <button i18n class="cancel" (click)="hideSellerApprovalWarning()">Close</button>
        </div>
      </ng-container>
  
      <!-- List on PunksMarket before acceptBid -->
      <ng-container *ngIf="acceptPunksmarketListingRequiredModalActive && pendingPunksmarketAcceptBid as pmListBid">
        <div class="punk-info">
          <h2>{{ acceptOnChainBidListingRequiredTitle }}</h2>
          <p>{{ acceptOnChainBidListingRequiredDescription }}</p>
          <p>
            Pending <app-on-chain-bid-label [iconSize]="14">{{ onChainBidNoun }}</app-on-chain-bid-label>:
            <span class="pink">{{ pmListBid.bid_amount_eth | formatCash }} ETH</span>
          </p>
        </div>
        <div class="form-actions">
          <button class="cancel" (click)="closeAcceptPunksmarketListingRequiredModal()">Cancel</button>
          <button class="submit punksmarket" (click)="openSellModalForPunksmarketAccept()">Offer for Sale</button>
        </div>
      </ng-container>

      <!-- ACCEPT PUNKSMARKET ON-CHAIN BID (V1 unwrapped directed listing) -->
      <ng-container *ngIf="acceptPunksmarketBidModalActive && pendingPunksmarketAcceptBid as pmAcceptBid">
        <div class="punk-info">
          <h2>
            {{ acceptOnChainBidModalTitle }}
            <span class="pink">{{ pmAcceptBid.bid_amount_eth | formatCash }} ETH</span>
          </h2>
          <p>{{ acceptOnChainBidModalDescription }}</p>
          <p *ngIf="punk.listing?.value as listingWei">
            Directed listing price:
            <span class="bold">{{ listingWei | weiToEth | formatCash }} ETH</span>
          </p>
          <p class="pink center">
            The router will call <code>acceptBid</code> on punksmarket.eth with bid #{{ pmAcceptBid.punksmarketBidId }}.
          </p>
        </div>

        <div class="form-actions">
          <button class="cancel" (click)="closeAcceptPunksmarketBidModal()">Cancel</button>
          <button class="submit punksmarket" (click)="confirmAcceptPunksmarketBid()">
            <app-on-chain-bid-label colorMode="contrast">{{ acceptOnChainBidButtonLabel }}</app-on-chain-bid-label>
          </button>
        </div>
      </ng-container>

      <!-- ACCEPT LEGACY BID -->
      <ng-container *ngIf="acceptBidModalActive">
        <div class="punk-info">
          <h2>{{ acceptNativeBidModalTitle }} <span class="pink">{{ punk.bid?.value || '0' | weiToEth }} ETH</span></h2>
          <h4>We recommend accepting bids with MEV Blocker RPC for added protection, but it's completely optional.</h4>
          <p class="pink center">MEV Blocker is an RPC endpoint that supports users by offering:</p>
          <ul>
            <li>Full protection from frontrunning and sandwich attacks on all types of transactions</li>
            <li>Profit from any backrunning opportunities your transactions create</li>
            <li>A fast, free, censorship-resistant solution open to all searchers and builders</li>
          </ul>
          <p>More info at <a href="https://mevblocker.io" target="_blank">mevblocker.io</a></p>
          <br />
  
          <button (click)="addMevBlockerNetwork()">Add MEV Blocker RPC to MetaMask</button>
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeAcceptBid()">Cancel</button>
          <button class="submit" (click)="acceptBidForPunk(punk)">{{ acceptNativeBidButtonLabel }}</button>
        </div>
      </ng-container>

      <!-- ACCEPT COLLECTION BID -->
      <ng-container *ngIf="acceptCollectionBidModalActive">
        <!-- Fixed Modal Header -->
        <div class="modal-header">
          <h2 i18n>Accept stash bid for <span class="pink">{{ selectedCollectionBid?.bid_amount_eth || '0' }} ETH</span></h2>
          
          <!-- Breadcrumb Stepper -->
          <div class="stepper-breadcrumb">
            <div class="step" [class.active]="currentAcceptStep === 'initial'" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'">
              <span class="step-number">1</span>
              <span class="step-label">Accept bid</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'offer'" [class.completed]="currentAcceptStep === 'accept'">
              <span class="step-number">2</span>
              <span class="step-label">Offer to stash</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'accept'">
              <span class="step-number">3</span>
              <span class="step-label">Complete transaction</span>
            </div>
          </div>
        </div>

        <div class="punk-info">
          <ng-container *ngIf="environment.collection === 'cryptopunks-v1' && !punk.wrapped; else standardMessage">
            <p i18n>To accept the collection bid, list your unwrapped {{ environment.tokenName }} #{{ punk.id }} for 0 ETH to the bidder's stash address on the V1 market. When you complete acceptance, the stash pays you in ETH and the punk stays native (no automatic wrap).</p>
          </ng-container>
          <ng-template #standardMessage>
            <p i18n>To accept the collection bid, you'll need to offer your {{ environment.tokenName }} #{{ punk.id }} to the stash address of the bidder.</p>
          </ng-template>
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeAcceptCollectionBid()">Cancel</button>
          <button i18n class="submit" (click)="acceptCollectionBidForPunk(punk)">Accept Collection Bid</button>
        </div>

      </ng-container>

      <!-- VIEW ALL COLLECTION BIDS -->
      <ng-container *ngIf="viewAllCollectionBidsModalActive && allBids.length > 0">
        <div class="collection-bids-close-row">
          <button class="close-modal" (click)="closeViewAllCollectionBids()">x</button>
        </div>
        <div class="punk-info">
          <h2 i18n>All Bids for {{ environment.tokenName }} #{{ punk.id }}</h2>
          <div class="image-wrapper">
            <img
              [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
              width="200"
              height="200"
            />
          </div>
        </div>
    
        <app-stash-bids-table
          [bids]="allBids"
          [showFilters]="false"
          [showPagination]="false"
          [showAcceptButton]="(punk.owner?.id | lowercase) === (stateSvc.getWalletAddress() | lowercase)"
          [canAcceptBidFn]="canAcceptCollectionBid"
          (acceptBid)="selectCollectionBid($event)"
          (copyBid)="openCopyBidModal($event)">
        </app-stash-bids-table>
      </ng-container>

      <!-- OFFER PUNK TO STASH -->
      <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false && offerToStashModalActive">
        <!-- Fixed Modal Header -->
        <div class="modal-header">
          <h2 i18n>Offer {{ environment.tokenName }} #{{ punk.id }} to Stash</h2>
          
          <!-- Breadcrumb Stepper -->
          <div class="stepper-breadcrumb">
            <div class="step" [class.active]="currentAcceptStep === 'initial'" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'">
              <span class="step-number">1</span>
              <span class="step-label">Accept bid</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'offer'" [class.completed]="currentAcceptStep === 'accept'">
              <span class="step-number">2</span>
              <span class="step-label">Offer to stash</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'accept'">
              <span class="step-number">3</span>
              <span class="step-label">Complete transaction</span>
            </div>
          </div>
        </div>

        <div class="punk-info">
          <ng-container *ngIf="environment.collection === 'cryptopunks-v1' && !punk.wrapped; else standardOfferMessage">
            <p i18n>List your unwrapped punk for sale at 0 ETH to the stash address below on the CryptoPunks V1 contract. The stash will buy it for 0 ETH, pay you the bid amount from its balance, and transfer native custody to the bidder.</p>
            <p><strong i18n>Bid Amount:&nbsp;</strong> <span class="pink">{{ selectedCollectionBid?.bid_amount_eth || '0' }} ETH</span></p>
            <p><strong i18n>Stash Address:</strong>&nbsp;
              <a
                [href]="'https://etherscan.io/address/' + (stashAddressForListing || '')"
                target="_blank"
                rel="noopener noreferrer">
                <app-wallet-address [address]="stashAddressForListing || ''"></app-wallet-address>
              </a>
            </p>
          </ng-container>
          <ng-template #standardOfferMessage>
            <p i18n>Before accepting this collection bid, you need to offer your punk for sale to the bidder's stash address.</p>
            <p><strong i18n>Bid Amount:&nbsp;</strong> <span class="pink">{{ selectedCollectionBid?.bid_amount_eth || '0' }} ETH</span></p>
            <p><strong i18n>Stash Address:</strong>&nbsp;
              <a
                [href]="'https://etherscan.io/address/' + (stashAddressForListing || '')"
                target="_blank"
                rel="noopener noreferrer">
                <app-wallet-address [address]="stashAddressForListing || ''"></app-wallet-address>
              </a>
            </p>
          </ng-template>
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeOfferToStashModal()">Cancel</button>
          <button i18n class="submit" (click)="offerPunkToStash(punk)">
            <ng-container *ngIf="environment.collection === 'cryptopunks-v1' && !punk.wrapped; else standardButton">
              Offer to Wrapper
            </ng-container>
            <ng-template #standardButton>
              Offer to Stash
            </ng-template>
          </button>
        </div>
      </ng-container>

      <!-- ACCEPT COLLECTION BID FINAL -->
      <ng-container *ngIf="acceptCollectionBidFinalModalActive">
        <!-- Fixed Modal Header -->
        <div class="modal-header">
          <h2 i18n>Complete Stash Bid Acceptance</h2>
          
          <!-- Breadcrumb Stepper -->
          <div class="stepper-breadcrumb">
            <div class="step" [class.active]="currentAcceptStep === 'initial'" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'">
              <span class="step-number">1</span>
              <span class="step-label">Accept bid</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'offer' || currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'offer'" [class.completed]="currentAcceptStep === 'accept'">
              <span class="step-number">2</span>
              <span class="step-label">Offer to stash</span>
            </div>
            <div class="step-separator" [class.completed]="currentAcceptStep === 'accept'"></div>
            <div class="step" [class.active]="currentAcceptStep === 'accept'">
              <span class="step-number">3</span>
              <span class="step-label">Complete transaction</span>
            </div>
          </div>
        </div>

        <div class="punk-info">
          <p i18n>You are about to accept the collection bid for <span class="pink">{{ selectedCollectionBid?.bid_amount_eth || '0' }} ETH</span>.</p>
          <p i18n>This will complete the acceptance process and transfer your {{ environment.tokenName }} #{{ punk.id }} to the bidder.</p>
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeAcceptCollectionBidFinalModal()">Cancel</button>
          <button i18n class="submit" (click)="executeAcceptCollectionBidTransaction(punk)">Accept Stash Bid</button>
        </div>
      </ng-container>
  
      <!-- SELL -->
      <ng-container *ngIf="sellModalActive">
        <div class="punk-info">
          <h2 i18n>Offer {{ environment.tokenName }} #{{ punk.id }} For Sale</h2>
          <div class="image-wrapper">
            <img
              [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
              width="200"
              height="200"
            />
          </div>
        </div>
    
        <div class="form-group">
          <label i18n for="list-price">Asking Price in ETH (Ξ)</label>
          <input
            type="number"
            id="list-price"
            [min]="0"
            [formControl]="listPrice"
            [readonly]="!!pendingPunksmarketAcceptBid" />
          <p
            class="punksmarket-listing-notice"
            *ngIf="pendingPunksmarketAcceptBid as pmPrefillBid">
            {{ acceptOnChainBidListingPriceHint }}
            <span class="bold">
              ({{ pmPrefillBid.bid_amount_eth | formatCash }} ETH — bid #{{ pmPrefillBid.punksmarketBidId }})
            </span>
          </p>
          <div
            class="floor-notice"
            *ngIf="
              !pendingPunksmarketAcceptBid &&
              listPrice.value !== null &&
              (listPrice.value ?? 0) < ((dataSvc.currentFloor$ | async) || 0) &&
              listPrice.value !== 0
            ">
            You are listing below floor price!
          </div>
        </div>

        <p
          class="punksmarket-listing-notice"
          *ngIf="environment.collection === 'cryptopunks-v1' && !punk.wrapped && isPunksmarketNativeTradingEnabled() && !pendingPunksmarketAcceptBid"
          i18n>
          This listing is directed to PunksMarket for secure settlement on the native V1 contract. Only buyers settling through PunksMarket can purchase this punk.
        </p>

        <div class="form-group" *ngIf="!(environment.collection === 'cryptopunks-v1' && !punk.wrapped && isPunksmarketNativeTradingEnabled())">
          <label i18n for="list-to-address">Offer to Address (0x or ens)</label>
          <input
            type="text"
            id="list-to-address"
            [placeholder]="'Anyone'"
            [formControl]="listToAddress"
            role="presentation"
            autocomplete="off"
          />
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeListing()">Cancel</button>
          <button i18n class="submit" (click)="submitListing(punk)">Offer {{ environment.tokenName }}</button>
        </div>
      </ng-container>
  
      <!-- BID -->
      <ng-container *ngIf="bidModalActive">
        <div class="punk-info">
          <h2 i18n>Bid on {{ environment.tokenName }} {{ punk.id }}</h2>
          <div class="image-wrapper">
            <img
              [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
              width="200"
              height="200" />
          </div>
        </div>
    
        <div class="form-group">
          <label i18n for="bid-price">Bid Price (Ξ)</label>
          <input type="number" id="bid-price" [formControl]="bidPrice" placeholder="0" />
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeBid()">Cancel</button>
          <button i18n class="submit" (click)="submitBid(punk)">Submit</button>
        </div> 
      </ng-container>
  
      <!-- Transfer -->
      <ng-container *ngIf="transferModalActive">
        <div class="punk-info">
          <h2 i18n>Transfer {{ environment.tokenName }} {{ punk.id }}</h2>
          <div class="image-wrapper">
            <img
              [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punk.id | tokenIdParse) + '.svg'"
              width="200"
              height="200" />
          </div>
        </div>
    
        <div class="form-group">
          <label i18n for="transfer-address">Transfer to address</label>
          <input
            type="text"
            id="transfer-address"
            [formControl]="transferAddress"
            placeholder="0x or .ens"
            role="presentation"
            autocomplete="off"
          />
          <div
            class="floor-notice"
            *ngIf="
              transferAddress.value?.toLowerCase() === '0x000000000000000000000000000000000000dead' ||
              transferAddress.value?.toLowerCase() === '0x0000000000000000000000000000000000000000'
            ">
            
            Transfering to the burn address is disabled.
          </div>
        </div>
    
        <div class="form-actions">
          <button i18n class="cancel" (click)="closeTransfer()">Cancel</button>
          <button i18n
            class="submit"
            (click)="submitTransfer(punk)"
            [class.disabled]="
              transferAddress.value?.toLowerCase() === '0x000000000000000000000000000000000000dead' ||
              transferAddress.value?.toLowerCase() === '0x0000000000000000000000000000000000000000'
            ">
            
            Submit
          </button>
        </div>
      </ng-container>

      <!-- LOWER BID CONFIRMATION MODAL -->
      <app-lower-bid-confirmation-modal
        [isActive]="lowerBidConfirmationModalActive"
        (confirmed)="confirmLowerBidAcceptance()"
        (cancelled)="cancelLowerBidAcceptance()">
      </app-lower-bid-confirmation-modal>
    </ng-container>
    <p *ngIf="environment.collection === 'cryptopunks'">
      By interacting with this App, you agree to our <a [href]="'/assets/tos-'+environment.collection+'.pdf'" target="_blank">Terms of Use</a>. 
      Collection bids created on <a href="https://cryptopunks.eth.limo" target="_blank" rel="noopener noreferrer">Cryptopunks.eth.limo</a> are using the official and audited CryptoPunks Stash contract created by <a href="https://x.com/0xQuit" target="_blank" rel="noopener noreferrer">0xQuit</a> from Yuga Labs.
    </p>
    <p *ngIf="environment.collection === 'cryptopunks-v1'">
      By interacting with this App, you agree to our <a [href]="'/assets/tos-'+environment.collection+'.pdf'" target="_blank">Terms of Use</a>. 
      Collection bids created on <a href="https://v1cryptopunks.com" target="_blank" rel="noopener noreferrer">v1cryptopunks.com</a> are using a fork of the Stash contract created by <a href="https://x.com/0xQuit" target="_blank" rel="noopener noreferrer">0xQuit</a> from Yuga Labs.
    </p>
              
  </div>
</div>

<ng-template #usdValue let-ethValue>
  (${{ ((ethValue | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }})
</ng-template>

<ng-template #detailsPlaceholder>
  <div class="details-wrapper">

    <div class="title-wrapper">
      <div class="left">
        <h1 i18n>Loading...</h1>
        <h2 i18n>&nbsp;</h2>
      </div>
    </div>

    <div class="accessories-wrapper">
      <h2 i18n></h2>
      <div class="accessories">
        <div
          class="accessory"
          *ngFor="let item of [0, 1, 2]">

          <span class="value"></span>
          <span class="trait-count"></span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #auctionIcon>
  <svg height="24" viewBox="0 0 26 24" width="26" xmlns="http://www.w3.org/2000/svg"><g fill="#d8d8d8" fill-rule="evenodd"><path d="m10 0h2v2h-2z"/><path d="m8 2h2v2h-2z"/><path d="m6 4h2v2h-2z"/><path d="m6 6h2v2h-2z"/><path d="m8 8h2v2h-2z"/><path d="m10 10h2v2h-2z"/><path d="m8 12h2v2h-2z"/><path d="m6 14h2v2h-2z"/><path d="m4 16h2v2h-2z"/><path d="m2 18h2v2h-2z"/><path d="m8 10h2v2h-2z"/><path d="m6 12h2v2h-2z"/><path d="m4 14h2v2h-2z"/><path d="m2 16h2v2h-2z"/><path d="m0 18h2v2h-2z"/><path d="m12 12h2v2h-2z"/><path d="m14 14h2v2h-2z"/><path d="m18 20h2v2h-2z"/><path d="m20 20h2v2h-2z"/><path d="m22 20h2v2h-2z"/><path d="m24 20h2v2h-2z"/><path d="m22 22h2v2h-2z"/><path d="m20 22h2v2h-2z"/><path d="m18 22h2v2h-2z"/><path d="m16 22h2v2h-2z"/><path d="m16 20h2v2h-2z"/><path d="m14 20h2v2h-2z"/><path d="m16 14h2v2h-2z"/><path d="m18 12h2v2h-2z"/><path d="m20 10h2v2h-2z"/><path d="m20 8h2v2h-2z"/><path d="m18 6h2v2h-2z"/><path d="m12 0h2v2h-2z"/><path d="m14 2h2v2h-2z"/><path d="m16 4h2v2h-2z"/></g></svg>
</ng-template>

<ng-template #noBids>
  <p>
    There are currently no {{ nativeBidNounPlural }} on this {{ environment.tokenName }}.
  </p>
</ng-template>

<ng-template #popupIcon>
  <svg class="popup-icon" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
    <path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd"></path>
  </svg>
</ng-template>


<!-- Not for sale -->
<ng-template #notListed>
  <p i18n>This {{ environment.tokenName }} is currently not for sale.</p>
</ng-template>


<ng-template #collectionBidsLink>
  <div style="margin-top: 1.5rem; margin-bottom: 1.5rem; width: 460px; text-align: center;">
    <a
      *ngIf="(environment.collection === 'cryptopunks' || environment.collection === 'cryptopunks-v1') && allBids.length > 0"
      class="collection-bids-link"
      (click)="viewAllCollectionBids()"
      style="text-align: center; color: var(--pink, #ff00ff); text-decoration: none; border-bottom: 1px solid rgb(var(--text-color)); cursor: pointer; font-size: 1.3rem;">
        {{ allBids.length }} bid{{ allBids.length > 1 ? 's' : '' }} matching this punk
    </a>
  </div>
</ng-template>

<!-- Individual Bid Creation Modal -->
<app-bid-creation-modal
  [isActive]="individualBidModalActive"
  [bidType]="'targeted'"
  [selectedPunkIds]="individualBidSelectedPunkIds"
  (modalClosed)="closeIndividualBidModal()"
  (bidCreated)="onIndividualBidCreated()">
</app-bid-creation-modal>

<!-- Bid Copy Confirmation Modal -->
<app-bid-copy-confirmation-modal
  [isActive]="copyConfirmationModalActive"
  [punkIds]="copyConfirmationPunkIds"
  (confirmed)="onCopyConfirmed()"
  (cancelled)="onCopyCancelled()">
</app-bid-copy-confirmation-modal>

<!-- Copy Bid Creation Modal -->
<app-bid-creation-modal
  [isActive]="copyBidModalActive"
  [bidType]="copyFromBidPayload?.bidType ?? 'collection'"
  [ownerAddress]="copyFromBidPayload?.ownerAddress ?? null"
  [punkIndices]="copyFromBidPayload?.punkIndices ?? []"
  [selectedPunkIds]="copyFromBidPayload?.selectedPunkIds ?? []"
  [activeTraits]="copyFromBidPayload?.activeTraits ?? []"
  [filterTag]="copyFromBidPayload?.filterTag ?? ''"
  [copyFromBid]="copyFromBidPayload"
  (modalClosed)="closeCopyBidModal()"
  (bidCreated)="onCopyBidCreated()">
</app-bid-creation-modal>

<app-punksmarket-place-bid-modal
  [isActive]="punksmarketPlaceBidModalActive"
  [punkId]="(punk$ | async)?.id ?? null"
  mode="targeted"
  (modalClosed)="closePunksmarketPlaceBidModal()"
  (bidPlaced)="onPunksmarketBidPlaced()">
</app-punksmarket-place-bid-modal>